<template>
  <footer id="cookie-overlay" class="fixed-pane" :class="wrapperClasses">
    <div class="inner">
      <div v-if="!agreed">
        <p class="message" v-html="notice"></p>
        <button class="agree" @click.prevent="agree">Agree</button>
        <button class="disagree" @click.prevent="disagree">Disagree</button>
      </div>
      <p v-if="agreed" class="message" v-html="thankyou"></p>
      <p v-if="disagreed" class="message" v-html="disagreedMessage"></p>
    </div>
  </footer>
</template>
<script type="text/javascript">
import {getCookie, setCookie} from "../lib/utils";

export default {
  name: 'CookieCompliance',
  data: function () {
    return {
      show: false,
      agreed: false,
      disagreed: false,
      notice: "We use cookies and local storage to improve user experience. By accepting cookies you consent to store on your device all the technologies described in our Cookie Policy. You can change your cookie settings at any time by clicking <em>Storage Settings</em>. Please read our Terms and Conditions and Privacy Policy for full details.",
      thankyou: "Thank you for agreeing to a little temporary storage",
      disagreedMessage: "We respect your choice. All temporary storage has been removed."
    }
  },
  created() {
    let agreedCookie = getCookie('cookies');
    if (agreedCookie !== 'agreed') {
      setTimeout(() => {
        this.prompt();
      }, 5000);
    }
    
  },
  computed: {
    wrapperClasses() {
      let cls = [];
      if (this.show) {
        cls.push('show');
      }
      if (this.agreed) {
        cls.push('agreed');
      } else if (this.disagreed) {
        cls.push('disagreed');
      }
      return cls;
    },
  },
  methods: {
    prompt() {
      this.show = true;
    },
    agree() {
      setCookie('cookies', 'agreed', 7);
      this.agreed = true;
      this.disagreed = false;
      setTimeout(() => {
        this.show = false;
      }, 4000);
    },
    disagree() {
      this.disagreed = true;
      this.agreed = false;
      this.$ls.remove('all-panes');
      this.$ls.remove('scheme');
      this.$parent.mayStore = false;
      setTimeout(() => {
        this.show = false;
      }, 10000);
    }
  }
}
</script>


// WEBPACK FOOTER //
// CookieCompliance.vue?670a8116